var map = {
	"./chat-icon-bottom-nav-mobile-active.webp": 2692,
	"./chat-icon-bottom-nav-mobile.webp": 2693,
	"./home-icon-bottom-nav-mobile-active.webp": 2694,
	"./home-icon-bottom-nav-mobile-active_b.webp": 2695,
	"./home-icon-bottom-nav-mobile.webp": 2696,
	"./home-icon-bottom-nav-mobile_b.webp": 2697,
	"./me-icon-bottom-nav-mobile-active.webp": 2698,
	"./me-icon-bottom-nav-mobile.webp": 2699,
	"./promo-icon-bottom-nav-mobile-active.webp": 2700,
	"./promo-icon-bottom-nav-mobile.webp": 2701,
	"./sponsor-icon-bottom-nav-mobile-active.webp": 2702,
	"./sponsor-icon-bottom-nav-mobile.webp": 2703,
	"./stream-icon-bottom-nav-mobile-active.webp": 2704,
	"./stream-icon-bottom-nav-mobile.webp": 2705
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2691;